export default __webpack_public_path__ + "static/media/LUP4LDN-LOGO_small.7d5bc72d.png";